module.exports = __webpack_public_path__ + "static/media/folder.31ca7ee0.svg";